import { Level2Wrapper } from '../common/Level2Wrapper';
import { GenericSubSection } from '../common/GenericSubSection';
import { useDriveCyclesSection } from '../../hooks/useDriveCyclesSection';

export const DriveCycles = () => {
  const section = useDriveCyclesSection();

  return (
    <Level2Wrapper flex="1 1 100%" label="Drive Cycles">
      {Object.values(section?.subsections ?? {}).map(sub => (
        <GenericSubSection key={sub.id} section={sub} />
      ))}
    </Level2Wrapper>
  );
};
